<template>
    <div class="form social-normal">
        <div class="small-wrap">
            <h1>{{ data.name.charAt(0).toUpperCase() + data.name.slice(1) }}<span class="purple-text">.</span></h1>

            <div class="white-box-wrap">
                <span class="white-box"><img :src="'/img/logos/' + data.icon_color"/></span>
            </div>

            <input-group v-model="form.url" :val="form.url" name="url" :placeholder="data.text_url"
                         :valid="(errors.url && errors.urlFormat)" :showErrors="showErrors">
                <template v-slot:errorMessage>
                    {{ (!errors.url) ? 'Wypełnij to pole' : 'Podaj poprawną wartość' }}
                </template>
            </input-group>

            <input-group v-model="form.score" :val="form.score" name="score" :placeholder="data.text_subscribers"
                         class="score" :valid="errors.score" :showErrors="showErrors" pattern="\d*">
                <template v-slot:errorMessage>Wypełnij to pole</template>
            </input-group>

            <h4>Zasady współpracy</h4>

            <div class="barter-buttons">
                <icon-text-checkbox :nolabel="true" v-model="form.isBarter" :value="form.isBarter">
                    <template v-slot:image>
                        <img src="../../../assets/barter_icon.png"/>
                    </template>
                </icon-text-checkbox>

                <icon-text-input-checkbox :nolabel="true" v-model="form.isPaid" :value="form.isPaid"
                                          :value-income="form.income" v-on:income="incomeChange">
                    <template v-slot:image>
                        <img src="../../../assets/cash_icon.png"/>
                    </template>
                </icon-text-input-checkbox>
            </div>

            <form-error :show="!errors.barter && showErrors" className="barter-error">
                <template v-slot:errorMessage>
                    Wybierz zasadę współpracy
                </template>
            </form-error>

            <form-error :show="!errors.income && showErrors" className="income-error">
                <template v-slot:errorMessage>
                    Uzupełnij wynagrodzenie
                </template>
            </form-error>

            <div class="income-form">
                <span v-if="form.isBarter && !form.isPaid" class="income-label">Współpraca barterowa</span>
                <span v-if="!form.isBarter && form.isPaid" class="income-label">Tylko płatne wpisy</span>
                <span v-if="form.isBarter && form.isPaid" class="income-label">Współpraca barterowa lub płatna</span>
            </div>

            <div class="navigation next-navigation">
                <button v-on:click="handleNextStep" type="button" class="submit-purple-button">Dalej</button>
            </div>

        </div>

        <floating-navigation>
            <button v-on:click="$emit('go-back')" type="button" class="go-back-button"></button>
            <button v-on:click="$emit('cancel-step')" class="clear-right-button">pomiń {{data.name}}</button>
        </floating-navigation>
    </div>
</template>

<script>
    import InputGroup from "../elements/InputGroup";
    import IconTextCheckbox from "../elements/IconTextCheckbox";
    import IconTextInputCheckbox from "../elements/IconTextInputCheckbox";
    import FormError from "../elements/FormError";
    import Router from '../../../routing';
    import FloatingNavigation from "../elements/floatingNavigation";

    export default {
        name: "SocialNormal",
        components: {FloatingNavigation, FormError, IconTextInputCheckbox, IconTextCheckbox, InputGroup},
        props: ["data", "value", "index"],
        data: function () {
            return {
                baseUrl: Router.getBaseUrl(),
                showErrors: false,
                form: {
                    valid: true,
                    url: "",
                    score: "",
                    isBarter: false,
                    isPaid: false,
                    income: ""
                },
                errors: {
                    url: true,
                    urlFormat: true,
                    score: true,
                    barter: true,
                    income: true
                }
            }
        },
        mounted: function () {
            this.form = this.value;
        },
        async updated() {
            await this.$nextTick();
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent .initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
        },
        methods: {
            handleNextStep() {
                this.validate();

                if (this.isValid()) {
                    this.showErrors = false;
                    this.$emit('next-step');
                }
                else {
                    this.showErrors = true;
                }
            },
            incomeChange: function (income) {
                this.form.income = income;
            },
            validate: function () {
                this.errors.url = !(this.form.url.length === 0);
                this.errors.score = !(this.form.score.length === 0);

                this.errors.barter = (this.form.isPaid || this.form.isBarter);

                this.errors.income = (!this.form.isPaid || this.form.income && ((this.form.isPaid && (this.form.income.length))));

                if (this.errors.url && this.data.regex) {
                    let regex = RegExp(this.data.regex, 'i');
                    this.errors.urlFormat = regex.test(this.form.url);
                }

                this.form.valid = this.isValid();
            },
            hasData() {
                if (this.form.url.length) return true;
                if (this.form.score.length) return true;
                if (this.form.isBarter) return true;
                if (this.form.isPaid) return true;

                return false;
            },
            isValid() {
                if (!this.errors.url) return false;
                if (!this.errors.urlFormat) return false;
                if (!this.errors.score) return false;
                if (!this.errors.barter) return false;
                if (!this.errors.income) return false;

                return true;
            },
            resetErrors() {
                this.errors = {
                    url: true,
                    urlFormat: true,
                    score: true,
                    barter: true,
                    income: true,
                };
            }
        },
        watch: {
            form: {
                handler(val) {
                    this.validate();
                    this.$emit('input', val);
                },
                deep: true
            },

            value: {
                handler(val) {
                    this.form = val;
                },
                deep: true
            },

            index: function () {
                this.form = this.value;
                this.resetErrors();
                this.validate();
            }
        }
    }
</script>

<style scoped lang="scss">
</style>